import { icons } from "lucide-react";
import { PrivateOfficeAttributesEntity } from "../../adapters/get-privateroom/get-privateroom.types";

export const handleSelectIconCategory = (
  name: string,
): { icon: keyof typeof icons; name: string } => {
  switch (name) {
    case "entranceAndAccess":
      return {
        name: "Entrada e Acesso",
        icon: "KeyRound",
      };
    case "receptionAndSecurity":
      return {
        name: "Recepção e Segurança",
        icon: "UserCheck",
      };
    case "parkingAndTransportation":
      return {
        name: "Estacionamento e Transporte",
        icon: "SquareParking",
      };
    case "environmentAndClimateControl":
      return {
        name: "Ambiente e Climatização",
        icon: "Wind",
      };
    case "structureAndOffice":
      return {
        name: "Estrutura e Escritório",
        icon: "Laptop",
      };
    case "technologyAndConnectivity":
      return {
        name: "Tecnologia e Conectividade",
        icon: "Wifi",
      };
    case "servicesAndSupport":
      return {
        name: "Serviços de Apoio e Suporte",
        icon: "Wifi",
      };
    case "accessibility":
      return {
        name: "Acessibilidade",
        icon: "Accessibility",
      };
    case "supportServices":
      return {
        name: "Serviços de Suporte",
        icon: "HandHelping",
      };
    default:
      return {
        name,
        icon: "ChevronsRight",
      };
  }
};

type TextProps = {
  text: string;
  icon: keyof typeof icons | null;
};

const formatPrice = (price: string): string => {
  let formattedPrice = price.replace(",", ".");
  if (!formattedPrice.includes(".")) {
    formattedPrice += ",00";
  } else {
    const [integerPart, decimalPart] = formattedPrice.split(".");
    if (decimalPart.length === 1) {
      formattedPrice = `${integerPart},${decimalPart}0`;
    } else if (decimalPart.length === 0) {
      formattedPrice = `${integerPart},00`;
    } else {
      formattedPrice = `${integerPart},${decimalPart.slice(0, 2)}`;
    }
  }
  return formattedPrice.replace(".", ",");
};

export const getTextToBadge = (
  attribute: PrivateOfficeAttributesEntity,
): TextProps => {
  switch (attribute.content_type) {
    case "price":
      return {
        text: `${attribute?.content ? `R$ ${formatPrice(attribute.content)}` : "Não informado"}`,
        icon: null,
      };
    case "text":
      return {
        text: attribute.content,
        icon: "Info",
      };
    case "number":
      return {
        text: attribute.content,
        icon: "Info",
      };
    default:
      return {
        text: attribute.content,
        icon: "Info",
      };
  }
};

export const getTextToDescription = (text: string): string => {
  const formattedText = (text || "").toLowerCase();
  switch (true) {
    case formattedText.includes("price"):
      return "Valor";
    case formattedText.includes("hours"):
      return "Horas";
    case formattedText.includes("capacity"):
      return "Capacidade";
    case formattedText.includes("total"):
      return "Total";
    case formattedText.includes("included"):
      return "Incluso";
    default:
      return text;
  }
};
